import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Login from "../layout/Login";
import Logout from "../layout/Logout";
import Panel from "../layout/Panel";
import AdminLayout from "../layout/AdminLayout"; // con Sidebar y <Outlet />

import ProtectedRoute from "../components/ProtectedRoute";
import RequireSuperuser from "../components/RequireSuperuser";

import SelectRoutes from "./SelectRoutes";
import Unauthorized from "../pages/error/Unauthorized";

import AdminHome from "../pages/admin/AdminHome";
import AdminClientes from "../pages/admin/AdminClientes";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/router" element={<SelectRoutes />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/logout" element={<Logout />} />
        <Route path="/panel/*" element={<Panel />} />

        <Route
          path="/admin"
          element={
            <RequireSuperuser>
              <AdminLayout />
            </RequireSuperuser>
          }
        >
          {/* 👇 Redirige automáticamente a AdminHome si acceden a /admin */}
          <Route index element={<Navigate to="AdminHome" replace />} />
          <Route path="AdminHome" element={<AdminHome />} />
          <Route path="Logout" element={<Logout />} />
          <Route path="AdminClientes" element={<AdminClientes />} />
        </Route>

        <Route path="/unauthorized" element={<Unauthorized />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
